<template>
  <ActiveListWtxh v-if="siteId == 116" />
  <ActiveListDefault v-else />
</template>

<script>
import ActiveListDefault from "./activeListDefault.vue";
import ActiveListWtxh from "./activeListWtxh.vue";

export default {
  name: "ActiveListContainer",
  components: {
    ActiveListDefault,
    ActiveListWtxh,
  },
  data() {
    return {
      siteId: null,
    };
  },
  created() {
    let info = localStorage.getItem("siteInfo");
    if (info) {
      this.siteId = JSON.parse(info).id;
    }
  },
};
</script>
